import {Entrances} from './@entrances';

export const ENTRANCES = new Entrances();
